"use strict"; // https://html.spec.whatwg.org/multipage/window-object.html#browser-interface-elements

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var BarPropImpl = function BarPropImpl() {
  _classCallCheck(this, BarPropImpl);
}; // Since many BarProps do not apply to modern browsers,
// returning true in all cases seems to be common practice.


BarPropImpl.prototype.visible = true;
exports.implementation = BarPropImpl;